import { createSlice } from '@reduxjs/toolkit';

const selectedTileSlice = createSlice({
    name: 'selectedTile',
    initialState: null,
    reducers: {
        setSelectedTile: (state, action) => action.payload,
        clearSelectedTile: () => null,
    },
});

export const { setSelectedTile, clearSelectedTile } = selectedTileSlice.actions;
export default selectedTileSlice.reducer;